import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useGoogleStore = defineStore("google", {
    state: () => {
        return {
            loadings: false
        };
    },

    getters: {
        loading: (state) => state.loadings,
    },

    actions: {
        post(token) {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'login/google',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    token: token
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        localStorage.refresh = res.data.data.token
                        localStorage.token = res.data.data.token
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        }
    },
});